import AppointmentService from '../../../services/appointment/ServiceAppointment'


export default {
    props: ["status", "enabledColumns"],

    data() {
        return {
            headers: [{
                id: 0,
                text: '',
                sortable: false,
                value: "shippingDate"
            },
            {
                id: 1,
                text: 'FECHA CITA',
                sortable: false,
                value: "appointment"
            },
            {
                id: 2,
                text: 'DOCUMENTO',
                sortable: false,
                value: "document"
            },
            {
                id: 3,
                text: 'NOMBRE',
                value: "name",
                sortable: false
            },
            {
                id: 4,
                text: 'ESTADO PEDIDO',
                sortable: false,
                value: "status"
            }
            ],

            loading: false,
            appointment: [],
            totalAppointment: 0,
            pagination: {},
            rowsPerPageItems: [5, 10, 15, 20]
        }
    },
    computed: {
        customHeaders() {
            return this.enabledColumns ? this.headers.filter(header => this.enabledColumns[header.id]) : this.headers
        }
    },
    watch: {
        pagination: {
            handler() {
                this.getAppointment()
            },
            deep: true
        }
    },
    methods: {

        showColumn(i) {
            return !this.enabledColumns || i >= this.enabledColumns.length || this.enabledColumns[i];
        },
        onRowClick(item) {
            this.$emit("row-click", item);
        },
        async getAppointment() {
            this.loading = true;
            const { page, rowsPerPage } = this.pagination;
            let response = await AppointmentService.getAppointment(page - 1, rowsPerPage)
            this.loading = false
            this.appointment = response.data[0]
            this.totalAppointment = response.data[1]


            this.appointment.forEach(appointment => {
                switch (appointment.status) {
                    case 'CANCELED':
                        appointment.status = 'CANCELADO'
                        break;
                    case 'SCHEDULED':
                        appointment.status = 'AGENDADO'
                        break;
                    case 'DELIVERED':
                        appointment.status = 'ASISTIO'
                    default:
                        break;
                }
            });

        },
    }
}